import { useMemo, useState } from 'react';
import { Box, Paper, Typography } from '@mui/material';
import ReportesFiltersBar from './reportes/components/ReportesFiltersBar';
import ReporteKPIs from './reportes/components/ReporteKPIs';
import ReporteChart from './reportes/components/ReporteChart';
import ReporteTabla from './reportes/components/ReporteTabla';
import {
  buildReporte,
  computeKpis,
  createDefaultReportesFilters,
  REPORT_TYPE_LABELS,
} from './reportes/utils/reportesData';
import { filtersDateRangeInvalid } from './utils/inventarioFilters';

export default function Reportes({ state, gastosState }) {
  const [filters, setFilters] = useState(createDefaultReportesFilters);

  const gananciasDiarias = useMemo(
    () => state.obtenerGananciasDiarias?.() || [],
    [state.movimientos, state.gastos, state.ajustes, state.productos]
  );

  const reporte = useMemo(() => {
    if (filtersDateRangeInvalid(filters)) {
      return {
        periodos: [],
        metricKey: 'total',
        metricLabel: 'Total',
        totales: {},
        isProductSnapshot: false,
      };
    }

    return buildReporte({
      reportType: filters.reportType,
      movimientos: state.movimientos,
      productos: state.productos,
      gastos: gastosState?.gastos || state.gastos,
      categorias: gastosState?.categorias || [],
      gananciasDiarias,
      filters: { ...filters, metodo: state.metodo },
    });
  }, [
    filters,
    state.movimientos,
    state.productos,
    state.metodo,
    state.gastos,
    gastosState?.gastos,
    gastosState?.categorias,
    gananciasDiarias,
  ]);

  const kpis = useMemo(
    () => computeKpis(reporte.periodos, reporte.metricKey),
    [reporte.periodos, reporte.metricKey]
  );

  const invalidRange = filtersDateRangeInvalid(filters);

  return (
    <Box>
      <Paper sx={{ p: 3, borderRadius: 3, boxShadow: 3, mb: 3 }}>
        <Typography variant="h5" fontWeight="bold" mb={0.5}>
          Reportes
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Análisis comparativo de compras, ventas, gastos, inventario, utilidad bruta y utilidad operativa
        </Typography>
      </Paper>

      <ReportesFiltersBar
        filters={filters}
        onChange={setFilters}
        productos={state.productos}
      />

      {!invalidRange && (
        <>
          <ReporteKPIs kpis={kpis} metricLabel={reporte.metricLabel} />

          <ReporteChart
            periodos={reporte.periodos}
            metricKey={reporte.metricKey}
            metricLabel={reporte.metricLabel}
            isProductSnapshot={reporte.isProductSnapshot}
          />

          <ReporteTabla
            reportType={filters.reportType}
            productId={filters.productId}
            periodos={reporte.periodos}
            totales={reporte.totales}
            isProductSnapshot={reporte.isProductSnapshot}
          />
        </>
      )}

      {invalidRange && (
        <Paper variant="outlined" sx={{ p: 4, textAlign: 'center' }}>
          <Typography color="text.secondary">
            Corrige el rango de fechas para ver el reporte de{' '}
            {REPORT_TYPE_LABELS[filters.reportType]}.
          </Typography>
        </Paper>
      )}
    </Box>
  );
}
